











import { Zastosowanie } from "@megarax/client/src/resources/plm/Zastosowanie";
import { propertyToStringFn } from "@megarax/client/src/resources/plm/Property";

import {
  inject,
  provide,
  computed,
  createComponent,
} from "@vue/composition-api";
import {
  sheetOptionsSymbol,
  SheetHighlights,
} from "@/components/sheet/SheetEntries";
import { ZastosowanieCategoryAttribute } from "@megarax/client/src/resources/plm";

interface Props {
  value: Zastosowanie;
}

export default createComponent<Props>({
  components: {},
  name: "ZastosowanieSheet",
  props: {
    value: {
      required: true,
    },
  },
  setup(props, ctx) {
    const injectedHighlights: SheetHighlights = inject(sheetOptionsSymbol, {});
    if (injectedHighlights)
      provide(sheetOptionsSymbol, injectedHighlights[props.value.category.id!]);

    const attributes = computed(() =>
      props.value.category.attributes.sort((a, b) => a.index - b.index),
    );

    const getPropertyText = (attribute: ZastosowanieCategoryAttribute) => {
      const propertyValue = props.value.properties[attribute.key];
      const toStringFn = propertyToStringFn[attribute.type];
      return propertyValue ? toStringFn(propertyValue) : "-";
    };

    const getFullLabel = (attribute: ZastosowanieCategoryAttribute) =>
      attribute.label + (attribute.unit ? ` [${attribute.unit}]` : "");

    return { attributes, getPropertyText, getFullLabel };
  },
});
